export interface ConditionTranslationData {
  name: string;
  locale: string;
  text: string;
  html: string;
  htmlCancellation: string;
  htmlCheckIn?: string;
  htmlCheckOut?: string;
  htmlChildren?: string;
  htmlPets?: string;
  htmlGroups?: string;
  htmlExtraInfo?: string;
}

export class ConditionTranslation {
  private constructor(
    public readonly name: string,
    public readonly locale: string,
    public readonly text: string,
    public readonly html: string,
    public readonly htmlCancellation: string,
    public readonly htmlCheckIn?: string,
    public readonly htmlCheckOut?: string,
    public readonly htmlChildren?: string,
    public readonly htmlPets?: string,
    public readonly htmlGroups?: string,
    public readonly htmlExtraInfo?: string
  ) {}

  static of(data: ConditionTranslationData): ConditionTranslation {
    return new ConditionTranslation(
      data.name,
      data.locale,
      data.text,
      data.html,
      data.htmlCancellation,
      data.htmlCheckIn,
      data.htmlCheckOut,
      data.htmlChildren,
      data.htmlPets,
      data.htmlGroups,
      data.htmlExtraInfo
    );
  }
}
